var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.3862 7.94455C17.3709 5.16539 17.247 3.66016 16.2656 2.67883C15.1425 1.55566 13.3357 1.55566 9.72212 1.55566H8.44434C4.82951 1.55566 3.02273 1.55566 1.89957 2.67883C0.777676 3.80072 0.777676 5.60877 0.777676 9.22233V19.4446C0.777676 23.0581 0.777676 24.8662 1.89957 25.9881C3.02401 27.1112 4.82951 27.1112 8.44434 27.1112H9.72212C13.3357 27.1112 15.1425 27.1112 16.2656 25.9881C17.247 25.0067 17.3709 23.5015 17.3862 20.7223",
    stroke: "#666161",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7219 14.3333H26.333M26.333 14.3333L21.8608 10.5M26.333 14.3333L21.8608 18.1667",
    stroke: "#666161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.ec80c05eda15cacd2a61b85f6c3a9f12.svg";
export { ForwardRef as ReactComponent };